/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var activityList = makeEntityScaffold('SAGA.API.ACTIVITY_LIST', function (client, options) {
  return client.activities.getList(options).then(function (data) {
    return data.activities;
  });
});